/* This file is autogenerated, see readme.md for instructions */
import ExternalLinkSvgIcon from '@bloomreach/banana-theme/icons/external-link.svg?react';
import { forwardRef } from 'react';

import Icon from '../icon';

import type { ReactNode, Ref } from 'react';

import type { IconInstanceProps } from '../icon.types';

const ExternalLinkIcon = forwardRef((props: IconInstanceProps, forwardedRef: Ref<SVGSVGElement>): ReactNode => {
  return (
    <Icon {...props} ref={forwardedRef}>
      <ExternalLinkSvgIcon />
    </Icon>
  );
});

ExternalLinkIcon.displayName = 'ExternalLinkIcon';

export default ExternalLinkIcon;
